import React from 'react'
import { SimpleChoice } from '../../types'
import style from './choice.module.scss'
import DragIcon from '../../../../../../../../assets/svg/solo-chat/drag-handle-2.svg'
import CrossIcon from '../../../../../../../../assets/svg/solo-chat/circle-cross-2.svg';

export type TChoice = SimpleChoice["contentValue"]["choices"][0]

type Props = {
	index: number
	updateChoice: (key: keyof TChoice, value: any, index: number) => void
	removeChoice: (index: number) => void
	choice: TChoice
	mode: "view" | "edit" | "create"
	error: Record<string, string> | undefined
	clearError: (index: number, key: string) => void
}

export function Choice(props: Props) {
	const { choice, index, updateChoice, removeChoice, mode, error = {}, clearError } = props
	return (
	 <div className={style.choice}>
			{mode !== "view" && 
				<div className="drag-handle">
					<img src={DragIcon} alt="drag"/>
				</div>
			}

			<div className={style.id}>
				<input disabled={mode === "view"} autoFocus id="labelId" placeholder="Enter ID" value={choice.id} onChange={(e) => {
				  clearError(index, "id")
					const value = e.currentTarget.value
					updateChoice("id", value, index)
				}} />
				<span className={style.error}>{error.id}</span>
			</div>

			<div className={style.label}>
				<div style={{ flex: 1 }}>
					<input disabled={mode === "view"} id="choice" placeholder="Enter Label" value={choice.label} onChange={(e) => {
						clearError(index, "label")
						const value = e.currentTarget.value
						updateChoice("label", value, index)
					}} />
					<span className={style.error}>{error.label}</span>
				</div>

				{mode !== "view" && (
					<button>
						<img onClick={() => removeChoice(index)} src={CrossIcon} alt="remove"/>
					</button>
				)}
			</div>
	 </div>
	)
}
